<template>
    <div>
      <KaimonoList />
    </div>
  </template>
  
  <script>
  import KaimonoList from '@/components/kaimono/KaimonoList.vue'
  
  export default {
    name: 'KaimonoTop',
    components: {
      KaimonoList,
    },
    setup() {

      return {
      }
    }
  }
  </script>
  